import { render, staticRenderFns } from "./invoiceRedRecord.vue?vue&type=template&id=6abe254d&scoped=true"
import script from "./invoiceRedRecord.vue?vue&type=script&lang=js"
export * from "./invoiceRedRecord.vue?vue&type=script&lang=js"
import style0 from "./invoiceRedRecord.vue?vue&type=style&index=0&id=6abe254d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abe254d",
  null
  
)

export default component.exports